import { SearchIcon } from "@heroicons/react/solid";
import React from "react";
import { useSearchBox } from "react-instantsearch-core";
import { Input } from "components/common/Form";
import styles from "./Search.module.css";

export const SearchBox = () => {
  const { query, refine } = useSearchBox();

  return (
    <div className={styles.searchBox}>
      <Input
        type="search"
        placeholder="Search…"
        className={styles.searchInput}
        value={query}
        onChange={event => refine(event.currentTarget.value)}
      />
      <SearchIcon className={styles.searchIcon} />
    </div>
  );
};
